import { c as _c } from "react/compiler-runtime";
import styles from "@website/ui/digital-text-field/digital-text-field-cell.module.scss";
import { DigitalTextFieldCellPropertiesType } from "@website/ui/digital-text-field/digital-text-field.types";
import { FC } from "react";
export const DigitalTextFieldCell: FC<DigitalTextFieldCellPropertiesType> = properties => {
  const $ = _c(4);
  const {
    error,
    text,
    variant,
    focus,
    onClick
  } = properties;
  const t0 = `${styles["digital-text-field-cell"]} ${error ? styles.error : ""} ${focus ? styles.focus : ""} ${text ? styles.fill : ""} ${styles[variant || "box"]}`;
  let t1;
  if ($[0] !== onClick || $[1] !== t0 || $[2] !== text) {
    t1 = <div className={t0} onClick={onClick}>{text}</div>;
    $[0] = onClick;
    $[1] = t0;
    $[2] = text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};